import React, { useState } from 'react'
import IntlMessages from "../../../helpers/IntlMessages";
import { Button, Form, FormGroup, Label, Input, CustomInput } from 'reactstrap';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import sendEmail from "./sendEmail";
import ConfirmDialog from "./ConfirmDialog";
import subjectList from "./subjectList";
import { Alert } from "reactstrap";

const ReportProblem = (props) => {
    const [modal, setModal] = useState(false);
    const [formIsSent, setFormIsSent] = useState(false);
    const [formValues, setFormValues] = useState({
        subject: subjectList[props.locale][0],
        description: ""
    });


    const toggleModal = () => {
        if (Object.values(formValues).some(val => (!val || val == subjectList[props.locale][0]))) return;
        if (!isValidLength()) return;
        if (!isValidMultiPunctuation()) return;
        if (!isValidPunctuation()) return;
        setModal(!modal)
    };

    const toggleFormIsSent = () => setFormIsSent(!formIsSent);

    const handleChange = (key, value) => setFormValues(prev => ({ ...prev, [key]: value.trim() }));

    const submitForm = async () => {
        toggleModal();
        toggleFormIsSent();
        document.getElementById("reportForm").reset();
        await sendEmail(formValues, props);
        setTimeout(() => {
            props.history.push("/");
        }, 3000);
    }

    const isValidPunctuation = () => {
        if (!formValues.description) return false;
        const regexPunctuation = new RegExp(/[|+^<>[{}`'&$\]\\]/gmui);
        return !regexPunctuation.test(formValues.description);
    }

    const isValidMultiPunctuation = () => {
        if (!formValues.description) return false;
        const regexMultiPunctuation = new RegExp(/[()* ?!.=":;@|+^<>[{}`'&$\]\\]{4,}/gmui);
        return !regexMultiPunctuation.test(formValues.description);
    }

    const isValidLength = () => {
        if (!formValues.description) return false;
        const regexMinMaxLength = new RegExp(/^.{10,400}$/gmui);
        return regexMinMaxLength.test(formValues.description);
    }

    return (<>
        {formIsSent && (
            <div style={{ position: "fixed", zIndex: "9999", top: "5.2rem", right: "1rem" }}>
                <Alert isOpen={formIsSent} toggle={toggleFormIsSent}
                    color="success" style={{ width: "20rem", fontSize: "14px" }}>
                    The report has been submitted, we will inform you as soon as possible.
                </Alert>
            </div>
        )}
        <ConfirmDialog
            modal={modal}
            toggleModal={toggleModal}
            submitForm={submitForm}
        />
        <div>
            <h1 className='text-center align-middle w-100'>
                <IntlMessages id="menu.reportProblem" />
            </h1>
            <Form id="reportForm" onSubmit={(e) => e.preventDefault()}>
                <>
                    <FormGroup>
                        <Label for="selectProblemSubject" className="list-item-heading float-left mb-2">
                            <IntlMessages id="menu.problemSubject" />:
                        </Label>
                        <CustomInput
                            type="select"
                            id="selectProblemSubject"
                            name="subject"
                            onChange={(e) => handleChange("subject", e.target.value)}>
                            {subjectList[props.locale]?.map((subject) => (
                                <option value={subject}> {subject} </option>
                            ))}
                        </CustomInput>
                    </FormGroup>
                    {(subjectList[props.locale][0] == formValues.subject || !formValues.subject)
                        && <p class="text-danger"><IntlMessages id="menu.chooseTopic" /></p>}
                </>
                <>
                    <FormGroup className="position-relative">
                        <Label for="problemDescription" className="list-item-heading float-left mb-2">
                            <IntlMessages id="menu.problemDescription" />:
                        </Label>
                        <Input
                            type="textarea"
                            name="description"
                            id="problemDescription"
                            rows={10}
                            onChange={(e) => handleChange("description", e.target.value)}
                        />
                        <span
                            className="position-absolute"
                            style={{ right: "0.75rem", bottom: "0.3rem" }}>
                            {formValues.description.length} / 400
                        </span>
                    </FormGroup>
                    {formValues.description.length < 1
                        && <p class="text-danger"><IntlMessages id="menu.descriptionFieldCannotLeftEmpty" /></p>}
                </>
                <div className="text-center">
                    <Button onClick={toggleModal}>
                        <IntlMessages id="menu.sendReport" />
                    </Button>
                </div>
            </Form>
        </div>
    </>);
}

const mapStateToProps = ({ settings }) => {
    const { locale, hotelConfig } = settings;
    return { locale, hotelConfig };
};

export default injectIntl(
    connect(
        mapStateToProps,
    )(ReportProblem)
);
